import { call, fork, put, take } from 'redux-saga/effects';

import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

import { createCargoOrders } from './cargoes/orders';
import { createVesselOrders } from './vessels/orders';
import { createVesselSizes } from './vessels/size';

/**
 *
 * @param letter
 * @param typeLetter
 * @param server
 */
export function* updateLetter(letter, typeLetter = letter.type, server) {
    letter.type = typeLetter;
    
    const response = yield call(api.updateLetter, letter, server);

    if (response.status === 200) {
        if (response.data.eh === 'api') {
            response.data.owner = letter.owner;
        }

        yield put({
            type: actionTypes.UPDATE_LETTER.SUCCESS,
            data: response.data,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `Letter ${letter._id} was update`,
                level: 'success',
                _id: letter._id,
                autoDismiss: 2,
            },
        });

        console.log('updateLetter', letter, response);

        if (letter.type === 'cargo') {
            yield call(createCargoOrders, response);
        } else if (letter.type === 'vessel' && !letter.fromVesselSizes) {
            yield call(createVesselOrders, response);
        } else if (letter.type === 'vessel' && letter.fromVesselSizes) {
            yield call(createVesselSizes, response);
        }

        return response;
    }

    yield put({
        type: actionTypes.UPDATE_LETTER.FAILURE,
        errors: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: `Letter ${letter._id} something get wrong`,
            level: 'error',
            _id: Math.random(),
            autoDismiss: 999,
        },
    });

    return response;
}

export function* watchUpdateLetter() {
    while (true) {
        const { letter, typeLetter } = yield take(actionTypes.UPDATE_LETTER.REQUEST);
        yield fork(updateLetter, letter, typeLetter);
    }
}

/**
 * Get letter by id
 * */
export function* getLetter(id) {
    const response = yield call(api.getLetter, id);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_LETTER.SUCCESS,
            data: response.data,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `Letter ${id} was get`,
                level: 'success',
                _id: response.data._id,
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_LETTER.FAILURE,
        errors: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: `Letter ${id} something get wrong`,
            level: 'error',
            _id: Math.random(),
            autoDismiss: 99999,
        },
    });

    return response;
}

export function* watchGetLetter() {
    while (true) {
        try {
            const { id } = yield take(actionTypes.GET_LETTER.REQUEST);
            yield fork(getLetter, id);
        } catch (error) {
            yield put({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Error',
                    message: error.toString(),
                    level: 'error',
                    _id: Math.random(),
                    autoDismiss: 99999,
                },
            });
        }
    }
}

export function* saveAsSpam(data) {
    const response = yield call(api.saveAsSpam, data);

    if (response.status === 200) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Letter saved as spam',
                level: 'success',
                _id: Math.random(),
                autoDismiss: 25,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: 'Something went wrong',
            level: 'error',
            _id: Math.random(),
            autoDismiss: 50,
        },
    });

    return response;
}

export default [
    watchGetLetter,
    watchUpdateLetter,
];




// WEBPACK FOOTER //
// ./app/sagas/letters.js